import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  hexToRGBA,
  isDefined,
  isNotDefined,
  getStrokeDasharray,
  strokeDashTypes,
} from "../utils";

import GenericChartComponent from "../GenericChartComponent";
import { getAxisCanvas, getMouseCanvas } from "../GenericComponent";

class StraightLine extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
    this.isHover = this.isHover.bind(this);
  }
  isHover(moreProps) {
    const { highlightOnHover, hoverTolerance, type, yValue, xValue } =
      this.props;

    if (!highlightOnHover) return false;

    const { mouseXY } = moreProps;
    const {
      chartConfig: { yScale, origin, width, height },
    } = moreProps;
    const { xScale } = moreProps;

    let [x, y] = mouseXY;
    y += origin[1];
    x += origin[0];

    if (type === "horizontal") {
      const lineY = yScale(yValue) + origin[1];
      return Math.abs(y - lineY) <= hoverTolerance;
    } else {
      const lineX = xScale(xValue) + origin[0];
      return Math.abs(x - lineX) <= hoverTolerance;
    }
  }
  drawOnCanvas(ctx, moreProps) {
    const { type, stroke } = this.props;
    const { yValue, xValue } = this.props;
    const { xScale, hovering } = moreProps;
    const {
      chartConfig: { yScale, width, height },
    } = moreProps;

    ctx.beginPath();

    ctx.strokeStyle = hexToRGBA(stroke.color, stroke.opacity);
    ctx.lineWidth = hovering ? (stroke.width + 1) * 1.5 : stroke.width;

    const { x1, y1, x2, y2 } = getLineCoordinates(
      type,
      xScale,
      yScale,
      xValue,
      yValue,
      width,
      height,
    );

    ctx.setLineDash(getStrokeDasharray(stroke.dash).split(","));
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  }
  render() {
    const { highlightOnHover, onHover, onUnHover } = this.props;
    const hoverProps =
      highlightOnHover || onHover || onUnHover
        ? {
            isHover: this.isHover,
            drawOn: ["mousemove", "pan", "drag"],
            canvasToDraw: getMouseCanvas,
          }
        : {
            drawOn: ["pan", "drag", "mousemove"],
            canvasToDraw: getAxisCanvas,
          };

    return (
      <GenericChartComponent
        svgDraw={this.renderSVG}
        canvasDraw={this.drawOnCanvas}
        onClickWhenHover={this.props.onClick}
        onDoubleClickWhenHover={this.props.onDoubleClick}
        onContextMenuWhenHover={this.props.onContextMenu}
        onHover={this.props.onHover}
        onUnHover={this.props.onUnHover}
        {...hoverProps}
      />
    );
  }
  renderSVG(moreProps) {
    const { width, height, hovering } = moreProps;
    const {
      xScale,
      chartConfig: { yScale },
    } = moreProps;

    const { className } = this.props;
    const { type, stroke } = this.props;
    const { yValue, xValue } = this.props;

    const lineCoordinates = getLineCoordinates(
      type,
      xScale,
      yScale,
      xValue,
      yValue,
      width,
      height,
    );

    return (
      <line
        className={className}
        strokeDasharray={getStrokeDasharray(stroke.dash)}
        stroke={stroke.color}
        strokeWidth={hovering ? (stroke.width + 1) * 1.5 : stroke.width}
        strokeOpacity={stroke.opacity}
        {...lineCoordinates}
      />
    );
  }
}

function getLineCoordinates(
  type,
  xScale,
  yScale,
  xValue,
  yValue,
  width,
  height,
) {
  return type === "horizontal"
    ? {
        x1: 0,
        y1: Math.round(yScale(yValue)),
        x2: width,
        y2: Math.round(yScale(yValue)),
      }
    : {
        x1: Math.round(xScale(xValue)),
        y1: 0,
        x2: Math.round(xScale(xValue)),
        y2: height,
      };
}

StraightLine.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["vertical", "horizontal"]),
  hoverTolerance: PropTypes.number,
  highlightOnHover: PropTypes.bool,
  stroke: PropTypes.shape({
    color: PropTypes.string,
    opacity: PropTypes.number,
    width: PropTypes.number,
    dash: PropTypes.oneOf(strokeDashTypes),
  }),
  yValue: function (props, propName /* , componentName */) {
    if (props.type === "vertical" && isDefined(props[propName]))
      return new Error(
        "Do not define `yValue` when type is `vertical`, define the `xValue` prop",
      );
    if (props.type === "horizontal" && isNotDefined(props[propName]))
      return new Error("when type = `horizontal` `yValue` is required");
    // if (isDefined(props[propName]) && typeof props[propName] !== "number") return new Error("prop `yValue` accepts a number");
  },
  xValue: function (props, propName /* , componentName */) {
    if (props.type === "horizontal" && isDefined(props[propName]))
      return new Error(
        "Do not define `xValue` when type is `horizontal`, define the `yValue` prop",
      );
    if (props.type === "vertical" && isNotDefined(props[propName]))
      return new Error("when type = `vertical` `xValue` is required");
    // if (isDefined(props[propName]) && typeof props[propName] !== "number") return new Error("prop `xValue` accepts a number");
  },
  onHover: PropTypes.func,
  onUnHover: PropTypes.func,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

StraightLine.defaultProps = {
  className: "line ",
  type: "horizontal",
  hoverTolerance: 6,
  highlightOnHover: true,
  stroke: {
    color: "#000000",
    opacity: 0.5,
    width: 1,
    dash: "Solid",
  },
  onClick: function (e) {
    console.log("Click", e);
  },
  onDoubleClick: function (e) {
    console.log("Double Click", e);
  },
  onContextMenu: function (e) {
    console.log("Right Click", e);
  },
};

export default StraightLine;
